module.exports = new __parcel__URL__("machines_shield_battery_level_1.0086d681.png").toString();